import {defineStore} from 'pinia'
import {useApiRequestStore} from '../../ApiRequestStore/useApiRequestStore'
import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'
import {
  IMinimizedItemResponseInstance,
} from '@toolify/server/src/controllers/MinimizedItemController/types/IMinimizedItemResponseInstance'
import {
  IMinimizedItemViewState,
} from '@toolify/server/src/models/mongoose/MinimizedItemModel/types/IMinimizedItemViewState'
import {
  IGetMinimizedItemsRequestInterfaces,
} from '@toolify/server/src/controllers/MinimizedItemController/validators/GetMinimizedItems/types/IGetMinimizedItemsRequestInterfaces'
import {
  IMinimizeResourceRequestInterfaces,
} from '@toolify/server/src/controllers/MinimizedItemController/validators/MinimizeResource/types/IMinimizeResourceRequestInterfaces'
import {
  IUpdateMinimizedItemRequestInterfaces,
} from '@toolify/server/src/controllers/MinimizedItemController/validators/UpdateMinimizedItem/types/IUpdateMinimizedItemRequestInterfaces'
import {
  IDeleteMinimizedItemRequestInterfaces,
} from '@toolify/server/src/controllers/MinimizedItemController/validators/DeleteMinimizedItem/types/IDeleteMinimizedItemRequestInterfaces'
import {
  IDeleteMinimizedItemsRequestInterfaces,
} from '@toolify/server/src/controllers/MinimizedItemController/validators/DeleteMinimizedItems/types/IDeleteMinimizedItemsRequestInterfaces'
import {mapMinimizedItemResponseInstance} from '@toolify/client/src/modules/api/singletons/mapMinimizedItemResponseInstance'

export const useMinimizedItemApiStore = defineStore('minimizedItemApi', {
  actions: {
    async getMinimizedItems(workspaceId: string): Promise<IMinimizedItemResponseInstance[]> {
      const apiRequestStore = useApiRequestStore()
      const {minimizedItems} = await apiRequestStore.get<IGetMinimizedItemsRequestInterfaces>(`/workspace/${workspaceId}/minimized-items`)
      return minimizedItems.map(minimizedItem => mapMinimizedItemResponseInstance(minimizedItem))
    },

    async minimizeResource(
      resourceType: ResourceType,
      resourceId: string,
      viewState: IMinimizedItemViewState,
      position: number | null = null,
    ): Promise<IMinimizedItemResponseInstance> {
      const apiRequestStore = useApiRequestStore()
      const {minimizedItem} = await apiRequestStore.put<IMinimizeResourceRequestInterfaces>(`/resource/${resourceType}/${resourceId}/minimized`, {
        data: {
          viewState,
          position,
        },
      })
      return mapMinimizedItemResponseInstance(minimizedItem)
    },

    async updateMinimizedItem(
      resourceType: ResourceType,
      resourceId: string,
      changes: {position?: number | null, markSeen?: boolean | null},
    ): Promise<IMinimizedItemResponseInstance> {
      const apiRequestStore = useApiRequestStore()
      const {minimizedItem} = await apiRequestStore.patch<IUpdateMinimizedItemRequestInterfaces>(`/resource/${resourceType}/${resourceId}/minimized`, {
        data: changes,
      })
      return mapMinimizedItemResponseInstance(minimizedItem)
    },

    async deleteMinimizedItem(resourceType: ResourceType, resourceId: string): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.delete<IDeleteMinimizedItemRequestInterfaces>(`/resource/${resourceType}/${resourceId}/minimized`)
    },

    async deleteMinimizedItems(workspaceId: string, resourceIds: string[]): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.post<IDeleteMinimizedItemsRequestInterfaces>(`/workspace/${workspaceId}/minimized-items/delete`, {
        data: {
          resourceIds,
        },
      })
    },
  },
})
